/* eslint-disable */

import User from '../currentUser';
import { setFlagValue } from './api';
const user = new User();

window.scormObj = {};
window.scormMainContent = {};

scormObj.submitSCORMData = function() {};

SCORM.setLMSValues = function(object, method, flageReset, isEnrolled) {
  // isEnrolled = false;
  if (flageReset) {
    data = {};
    setFlagValue('flagInitialized', false);
    setFlagValue('flagFinished', false);
  }
  // if(isEnrolled) {
  scormMainContent = Object.assign({}, { ...JSON.parse(object.scormData) });
  // }
  /*if(!isEnrolled) {
    scormMainContent['lesson_mode'] = 'browse';
    scormMainContent['credit'] = 'no-credit';
  }*/
  scormObj = object;

  // debugger;
  // console.log('temp:: ', temp);
  scormObj.submitSCORMData = method;
};

SCORM.getValueFromLMS = function($varname) {
  let $varvalue = null;
  switch ($varname) {
    case 'cardId':
      $varvalue = scormObj.cardId;
      break;
    case 'cardPid':
      $varvalue = scormObj.cardPid;
      break;

    case 'cardPerformanceComplete':
      $varvalue = scormObj.cardPerformanceComplete;
      break;

    case 'cardPerformanceId':
      $varvalue = scormObj.cardPerformanceId;
      break;

    case 'cmi.core.student_name':
      $varvalue = user.name();
      break;

    case 'cmi.core.lesson_mode':
      $varvalue = scormMainContent.lesson_mode;
      break;

    case 'cmi.mode':
      $varvalue = scormMainContent.lesson_mode;
      break;

    case 'cmi.suspend_data':
      $varvalue = scormMainContent.suspend_data || '';
      break;

    case 'cmi.learner_name':
      $varvalue = user.name();
      break;

    case 'cmi.core.student_id' || 'cmi.learner_id':
      $varvalue = user.id();
      break;

    case 'cmi.learner_id':
      $varvalue = user.id();
      break;

    case 'adlcp:masteryscore':
      $varvalue = scormObj.mastery_score;
      break;

    case 'cmi.core.score.raw':
      $varvalue = scormMainContent.score_raw;
      break;

    case 'cmi.score.raw':
      $varvalue = scormMainContent.score_raw;
      break;

    case 'cmi.core.lesson_location':
      $varvalue = scormMainContent.lesson_location;
      break;

    case 'cmi.location':
      $varvalue = scormMainContent.lesson_location || '';
      break;

    case 'cmi.launch_data':
      $varvalue = '';
      break;

    case 'cmi.core.credit':
      $varvalue = scormMainContent.credit;
      break;

    case 'cmi.credit':
      $varvalue = scormMainContent.credit;
      break;

    case 'cmi.core.lesson_status':
      $varvalue = scormMainContent.lesson_status;
      break;

    case 'cmi.completion_status':
      $varvalue = scormMainContent.lesson_status;
      break;

    case 'cmi.core.entry':
      $varvalue = scormMainContent.entry;
      break;

    case 'cmi.entry':
      $varvalue = scormMainContent.entry;
      break;

    case 'cmi.core.total_time':
      // debugger;
      $varvalue = scormMainContent.total_time;
      break;

    case 'cmi.total_time':
      $varvalue = scormMainContent.total_time;
      break;

    case 'cmi.progress_measure':
      $varvalue = scormMainContent.progress_measure;
      break;

    case 'cmi.interactions._count':
      if (
        scormMainContent.interactions === 'null' ||
        (scormMainContent.interactions && !JSON.parse(scormMainContent.interactions))
      ) {
        $varvalue = 0;
        break;
      }
      $varvalue = scormMainContent.interactions && JSON.parse(scormMainContent.interactions).length;
      break;

    case 'cmi.interactions':
      $varvalue = scormMainContent.interactions && JSON.parse(scormMainContent.interactions);
      break;

    default:
      $varvalue = '';
  }
  return $varvalue;
};
